import { render, staticRenderFns } from "./PatientMedicalRecordsForm.vue?vue&type=template&id=083e8709&"
import script from "./PatientMedicalRecordsForm.vue?vue&type=script&lang=js&"
export * from "./PatientMedicalRecordsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports